import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { StorageService } from '../services/storage.service';
import { enumPerfil } from '../classes/Usuario';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: "root"
  })
export class LoginGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private storageService: StorageService,
    private translate: TranslateService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.loginService.usuarioEstaAutenticado()) {
      this.router.navigate(['/login']);
      return false;
    }

    const usuario = this.storageService.getUsuario();

    // Se o usuário é fornecedor ou fornecedor usuário, só permite acesso a rotas que começam com 'fornecedor/'
    if (usuario && (usuario.IsFornecedor || usuario.Perfil === enumPerfil.Fornecedor_Usuario)) {
      const url = state.url;
      let cleanUrl = url.startsWith('#') ? url.substring(1) : url;
      cleanUrl = cleanUrl.split('?')[0];

      if (cleanUrl.startsWith('/fornecedor/') || cleanUrl === '/login' || cleanUrl === '/' || cleanUrl === '' || cleanUrl === '/perfil') {
        if (cleanUrl === '/' || cleanUrl === '') {
          this.router.navigate(['/fornecedor/painel']);
          return false;
        }
        return true;
      }

      const VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO = this.translate.instant('VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO');
      const ACESSO_NEGADO = this.translate.instant('ACESSO_NEGADO');

      Swal.fire(ACESSO_NEGADO, VOCE_NAO_TEM_PERMISSAO_PARA_ACESSAR_ESTE_RECURSO, 'warning');
      this.router.navigate(['/fornecedor/painel']);
      return false;
    }

    return true;
  }
}

